import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const CustomIconmoon = styled(Iconmoon)`
  line-height: 1;
  font-size: 14px;

  &.icon-symbol_up:before {
    content: '\\25B2';
    display: inline-block;
    font-size: 12px;
    padding-bottom: 2px;
    padding-left: 2px;
  }
  &.icon-symbol_down:before {
    content: '\\25BC';
    display: inline-block;
    font-size: 12px;
    padding-bottom: 2px;
    padding-left: 2px;
  }
`;

export const ChartWrapper = styled.div`
  background: #FFFFFF;
  padding: 20px;
`;

export const HeroWrapper = styled.div`
  border: 1px solid #DADADA;
  border-radius: 4px;
  margin-bottom: 32px;
`;

export const ChartSectionItemContainer = styled(Flex)`
  gap: 20px;
`;

export const ChartSectionItem = styled.div`
  display: none;

  @media ${device.tablet} {
    padding-right: 20px;
    display: block;
    border-right: 1px solid #EDEDED;

    :last-child {
      border-right: unset;
    }
  }
`;

export const FollowerText = styled(Text).attrs({
  color: '#969696',
  size: '12px',
})`
  display: none;

  @media ${device.tablet} {
    cursor: pointer;
    display: block;
    margin-right: 10px;

    :hover {
      color: ${color.midgray};
    }
  }
`;
